import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TrendingUp, ArrowRight } from "lucide-react";
import { engagementApi, track, useViewed } from "@/lib/engagement";

// Radar Readoo: cosa cerca l'Italia (Google Trends), collegato alle notizie Readoo quando esistono.
export function RadarReadoo() {
  const [trends, setTrends] = useState([]);
  useEffect(() => { engagementApi.radar().then((r) => setTrends((r.trends || []).filter((t) => t.article?.path))).catch(() => {}); }, []);
  const ref = useViewed("radar_viewed", trends.length > 0);
  if (!trends.length) return null;
  return (
    <section ref={ref} data-testid="radar-readoo" className="rounded-2xl border border-hair bg-surfaceSecondary p-5 sm:p-6">
      <div className="flex items-baseline justify-between gap-3 mb-4">
        <div>
          <h2 className="flex items-center gap-2 font-serif text-xl font-semibold text-onSurface"><TrendingUp size={18} className="text-brand" /> Radar Readoo</h2>
          <p className="text-sm text-subtle">Cosa sta cercando l'Italia adesso</p>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-wider text-subtle shrink-0">Google Trends</span>
      </div>
      <ol className="divide-y divide-hair">
        {trends.map((t, i) => (
          <li key={t.slug} data-testid={`radar-trend-${i}`}>
            <Link to={t.article.path} data-testid={`radar-trend-link-${i}`} onClick={() => track("radar_trend_clicked", { trend: t.keyword })}
              className="group flex items-center gap-3 py-2.5">
              <span className="w-6 font-serif text-lg font-semibold text-brand tabular-nums">{i + 1}</span>
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold text-onSurface capitalize truncate">{t.keyword}</span>
                <span className="block text-xs text-subtle truncate group-hover:text-onSurface">{t.article.title}</span>
              </span>
              <ArrowRight size={14} className="text-brand shrink-0 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}
